import { useEffect } from "react";
import { Link } from "react-router-dom";
import { LegalLinks } from "@/components/LegalLinks";

export const LEGAL_UPDATED = "June 2026";
export const LEGAL_CONTACT = "contact@squadrumhome.com";

export const LegalPage = ({ title, intro, sections, testId }) => {
  useEffect(() => { window.scrollTo({ top: 0 }); document.title = `${title} · Squadrum`; }, [title]);
  return (
    <div className="min-h-screen bg-slate-50" data-testid={testId}>
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-16 max-w-3xl items-center px-5">
          <Link to="/" className="font-display text-lg font-extrabold tracking-tight text-slate-900" data-testid="legal-home-link">
            Squad<span className="text-[#C2410C]">rum</span>
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-10 sm:py-14">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="legal-title">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">Last updated: {LEGAL_UPDATED}</p>
        <p className="mt-6 text-[15px] leading-relaxed text-slate-700">{intro}</p>
        <div className="mt-8 space-y-8">
          {sections.map(([heading, paragraphs]) => (
            <section key={heading}>
              <h2 className="text-lg font-semibold text-slate-900">{heading}</h2>
              {paragraphs.map((p, i) => <p key={i} className="mt-2 text-[15px] leading-relaxed text-slate-700">{p}</p>)}
            </section>
          ))}
        </div>
        <LegalLinks className="mt-12 border-t border-slate-200 pt-6" />
      </main>
    </div>
  );
};
